module.exports = __webpack_public_path__ + "static/media/BADABB.0431c28f.TTF";